export default "/survey_assets/icons/lock-icon-green.79686fa8a86701cad87c823fbb6c412a.svg";